import { Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Loader } from '@/shared/ui/loader'
import { LabResearchDetailTab } from '@pages/donor-detail/ui/LabResearchDetailTab'

function LabResearchDetailRoute() {
  const { visitId, researchId } = Route.useParams()
  return (
    <Suspense fallback={<Loader />}>
      <LabResearchDetailTab
        visitId={visitId}
        researchId={researchId}
        basePath="/labarotaroyResearch"
      />
    </Suspense>
  )
}

export const Route = createFileRoute(
  '/_protected/labarotaroyResearch/$visitId/lab-research/$researchId',
)({
  component: LabResearchDetailRoute,
})
